import { html } from 'lit-element';
import { classMap } from 'lit-html/directives/class-map';

import { SimpleLitElement } from '@elab/components';
import connect from '@elab/core/store/connect';
import { paymentConstants } from '@elab/core/utils/constants';

class MyAccountPaymentCards extends SimpleLitElement {
    static get properties() {
        return {
            cardType: { type: String, attribute: 'card-type' },
            cardId: { type: String, attribute: 'card-id' },
            accountHolderName: { type: String, attribute: 'card-holder-name' },
            cardNumber: { type: String, attribute: 'card-number' },
            expiryMonth: { type: String, attribute: 'expiry-month' },
            expiryLabel: { type: String, attribute: 'expiry-label' },
            isExpired: { type: Boolean, attribute: 'is-expired' },
            expiryYear: { type: String, attribute: 'expiry-year' },
            cssClass: { type: Boolean, attribute: 'css-class' },
            removeCardLabel: { type: String, attribute: 'remove-card-label' },
            validLabel: { type: String, attribute: 'valid-label' },
            myCardLabel: { type: String, attribute: 'my-card-label' },
        };
    }

    constructor() {
        super();

        this.cardType = '';
        this.accountHolderName = '';
        this.cardNumber = '';
        this.expiryMonth = '';
        this.expiryYear = '';
        this.removeCardLabel = '';
        this.myCardLabel = '';
        this.url = '';
        this.expiryLabel = '';
        this.isExpired = false;
    }

    getLogoClassMap = () => {
        return classMap({
            'card-item__logo-image': true,
            'card-item__logo-image--master': this.cardType.includes(paymentConstants.MASTER),
            'card-item__logo-image--visa': this.cardType === paymentConstants.VISA,
            'card-item__logo-image--american': this.cardType === paymentConstants.AMERICAN,
            'card-item__logo-image--maestro': this.cardType === paymentConstants.MAESTRO,
        });
    };

    getCardImageClass = () => {
        return classMap({
            'card-item__image': true,
            'card-item__expired': this.isExpired,
        });
    };

    getFormattedCardNumber = cardNumber => {
        let cardArray = cardNumber.match(/.{1,4}/g);

        return cardArray.join('  ');
    };

    render() {
        return html`
            <div class="card-item">
                <div class="card-item__container">
                    <div class="card-item__info">
                        <div class="card-item__card-type-container">
                            <i class="icon icon-card swipe-to-buy__icon-card"> </i>
                        </div>
                        <div class="card-item__info-column">
                            <span class="card-item__info-number">
                                ${this.getFormattedCardNumber(this.cardNumber)}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}

export default () =>
    customElements.define('e2-payment-cards', connect(null, null)(MyAccountPaymentCards));
